import { Component, Input } from '@angular/core';
import * as constants from '../../constants/constants';
import { ToastController } from 'src/app/components/ionic-replacements/ToastController';

declare let OO: any;

@Component( {
  selector: 'simple-video-player',
  templateUrl: 'simple-video-player.html'
} )

export class SimpleVideoPlayerComponent {

  @Input() videoID: string;
  @Input() autoplay: boolean = true;
  @Input() videoPCode: string = 'dwdGgyOvm_d2UoFvVsOW3UK4Un4R';
  @Input() videoPlayerBrandId: string = 'b644c02543ad45638afcad87e8d1292a';
  @Input() videoMessageTitle: string = `Congratulations`;
  @Input() videoMessage: string = `Once you to see the amazing benefits of Vital Reds, you'll be grateful you stocked up.`;

  constructor(
    public toastCtrl: ToastController
  ) {
  }

}
